module.exports = __webpack_public_path__ + "img/20191114170016360截图20191114161439150.9e4d8eeb.jpg";